import React from "react";
import Edit from "./Edit";
import Overview from "./Overview";
export const AiChatInfo = () => {
  return (
    
      <Overview />
    
  );
};

export const EditAiChatInfo = () => {
  return (
    
      <Edit />
    
  );
};
